import React from "react";
import "./BioDisclosure.scss";
import AppLink from "@/components/AppLink";

const clean = (value) => String(value ?? "").trim();

export const disclosureOf = (agent) => {
  const given = agent?.disclosure;
  return {
    state: clean(given?.state || agent?.licenseState).toUpperCase() || null,
    brokerage: clean(given?.brokerage || agent?.Company) || null,
    license: clean(given?.license || agent?.licenseNo) || null,
    links: Array.isArray(given?.links)
      ? given.links.filter((link) => link && /^https:\/\//i.test(link.href || "") && clean(link.label))
      : [],
  };
};

// 22 TAC 531.20(b): the full "Texas Real Estate Commission Information About Brokerage Services"
// label needs 10pt (14px) or larger, a short "TREC ..." label 12pt (16px) or larger. Set inline so a
// stylesheet change cannot shrink them; the SCSS footer rule matches these values.
export const TREC_MIN_FONT_PX = { full: 14, short: 16 };
const FULL_TREC_LABEL = /^Texas Real Estate Commission/i;
const legalLinkStyle = (link) =>
  link.source === "trec"
    ? { fontSize: `${FULL_TREC_LABEL.test(clean(link.label)) ? TREC_MIN_FONT_PX.full : TREC_MIN_FONT_PX.short}px` }
    : undefined;

export const BioLegalLinks = ({ agent }) => {
  const { links } = disclosureOf(agent);
  if (!links.length) return null;
  return (
    <footer className="bio-disclosure bio-disclosure--footer">
      <ul className="bio-disclosure__links">
        {links.map((link) => (
          <li key={link.key || link.href}>
            <a href={link.href} target="_blank" rel="noopener noreferrer" style={legalLinkStyle(link)}>
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </footer>
  );
};

const BioDisclosure = ({ agent }) => {
  const { brokerage, license } = disclosureOf(agent);
  const brokeragePage = clean(agent?.BrokeragePage);
  if (!brokerage && !license) return null;

  return (
    <div className="bio-disclosure">
      {brokerage || license ? (
        <p className="bio-disclosure__identity">
          {brokerage ? (
            <span className="bio-disclosure__part">
              Agent at{" "}
              {brokeragePage ? (
                <AppLink className="bio-disclosure__brokerage" href={`/agents?b=${encodeURIComponent(brokeragePage)}`}>
                  {brokerage}
                </AppLink>
              ) : (
                <span className="bio-disclosure__brokerage">{brokerage}</span>
              )}
            </span>
          ) : null}
          {brokerage && license ? (
            <span className="bio-disclosure__dot" aria-hidden="true">
              ·
            </span>
          ) : null}
          {license ? <span className="bio-disclosure__part">License&nbsp;#{license}</span> : null}
        </p>
      ) : null}
    </div>
  );
};

export default BioDisclosure;
